module.exports = __webpack_public_path__ + "assets/img/warning.4b2fbd56.png";